import React from "react";
import TextInput from "../commons/TextInput";
import Commons from "oc-commons/Commons";
import CheckboxInput from "../commons/CheckboxInput";
import uiActions from "../../uiActions";
import SidebarFrame from "./SidebarFrame";
import Parts from "./overview/Parts";
import Dekore from "./overview/Dekore";
import Helper from "../../../model/Helper";

export default class Stammdaten extends SidebarFrame {
    renderTitle() {
        return I18N("Zusammenfassung");
    }

    downloadClicked(ev) {
        uiActions.pdf();
    }

    putIntoBasket(ev) {
        uiActions.basket();
    }

    saveClicked(ev) {
        uiActions.save();
    }

    favouritesClickes(ev) {}

    onChange(closure) {
        return (v) => {
            closure(v);
            this.forceUpdate();
        };
    }

    renderBody() {
        //TODO: SETTINGS!
        // return (<button className="button primary big-button"
        // onClick={() => this.saveClicked()} href="#">{I18N("Speichern")}</button>)

        const kunde = APP.arrangement.kunde;
        const admin = APP.settings.userRole == "admin";
        const adminAndInsipration = admin && APP.configuration.Inspiration;
        // small workaround for development
        const kundeValidate = kunde.validate();

        const allowedToSafe = (admin) || (kundeValidate && Commons.isEmpty(APP.configuration.ordered_at));
        return (
            <div id="stammdatenDialog" className="appear">
                <div className="spacer-before">
                    <dl>
                        <dt>{I18N("Maße:")}</dt>
                        <dd>
                            {APP.arrangement.schraenke
                                .map(
                                    (schrank) =>
                                        Helper.formatToRulerUnit(schrank.size.x) +
                                        " x " +
                                        Helper.formatToRulerUnit(schrank.size.y) +
                                        " x " +
                                        Helper.formatToRulerUnit(schrank.size.z)
                                )
                                .reduce((akku, curr, index) => (
                                    <React.Fragment key={index}>
                                        {" "}
                                        {akku} <br /> {curr}{" "}
                                    </React.Fragment>
                                ))}
                        </dd>
                        <dt>{I18N("Elemente:")}</dt>
                        <dd>
                            {APP.arrangement.schraenke
                                .map((schrank) => schrank.elements.length)
                                .reduce((akku, curr, index) => (
                                    <React.Fragment key={index}>
                                        {" "}
                                        {akku} <br /> {curr}{" "}
                                    </React.Fragment>
                                ))}
                            <br />
                        </dd>
                        <Parts arrangement={APP.arrangement} lookUpKey={"Einbauten"} label={"Ausstattung:"} />
                        <Parts arrangement={APP.arrangement} lookUpKey={"Türen"} label={"Türen:"} />
                        <Dekore arrangement={APP.arrangement} />
                        <Parts arrangement={APP.arrangement} lookUpKey={"Griffe"} label={"Griffe:"} />
                    </dl>
                </div>

                {adminAndInsipration ? (
                    <div>{I18N("Eine Inspiration hat keine Stammdaten")}</div>
                ) : (
                    <div>
                        <TextInput
                            id={"Sonderwuensche"}
                            placeholder={I18N("Notiz zum Schrank")}
                            label={I18N("Extras")}
                            type={"textarea"}
                            rows={"3"}
                            value={APP.arrangement.bemerkungen}
                            onChange={this.onChange((v) => (APP.arrangement.bemerkungen = v))}
                        />
                        <TextInput
                            id={"Nachname"}
                            placeholder={I18N("Ihr Name")}
                            label={I18N("Name") + ": *"}
                            value={kunde.Nachname}
                            onChange={this.onChange((v) => (kunde.Nachname = v))}
                        />
                        <TextInput
                            id={"EMailAdresse"}
                            placeholder={I18N("Ihre E-Mail")}
                            label={I18N("Email") + ": *"}
                            value={kunde.EMailAdresse}
                            onChange={this.onChange((v) => (kunde.EMailAdresse = v))}
                        />
                        <CheckboxInput
                            id={"dsChecked"}
                            label={I18N("Datenschutz")}
                            value={kunde.dsChecked}
                            onChange={this.onChange((v) => (kunde.dsChecked = v))}
                        />
                    </div>
                )}
                <div className="price-wrapper">
                    <h2> {I18N("Preis")} </h2>
                    <div className="price-inner">
                        <div className="price">{Helper.formatMoney(APP.arrangement.preis?.gesamtPreis)}</div>
                        {APP.settings.userLoggedIn && APP.arrangement.preis?.rabatt > 0 && (
                            <div className="rabatt">
                                - {Helper.formatMoney(APP.arrangement.preis?.rabatt)} [{I18N("Haendlerrabatt")}] ={" "}
                                {Helper.formatMoney(APP.arrangement.preis?.gesamtPreis - APP.arrangement.preis?.rabatt)}
                            </div>
                        )}
                        <div className="shipment">{I18N("Lieferung DE")}</div>
                    </div>
                </div>

                <div className="button-wrapper text-right">
                    {!admin && kundeValidate.length != 0 && (
                        <p>
                            {I18N("Feldpflicht")} {kundeValidate.join(", ")}
                        </p>
                    )}
                    {!Commons.isEmpty(APP.configuration.ordered_at) && <p>{I18N("Der Schrank wurde bereits bestellt")}</p>}

                    {/* TODO: VLL */}
                    {admin && (
                        <div className="text-left">
                            <hr></hr>
                            <p>Admin Panel</p>
                            <CheckboxInput
                                id={"inspiration"}
                                label={I18N("toInspiration")}
                                value={APP.toInspiration}
                                onChange={this.onChange((v) => (APP.toInspiration = v))}
                            />
                            <hr></hr>
                        </div>
                    )}

                    <button
                        className="button primary big-button"
                        disabled={!allowedToSafe}
                        onClick={() => this.saveClicked()}
                        href="#"
                    >
                        {I18N("Speichern")}
                    </button>

                    {APP.settings.customerPDF && (
                        <button onClick={() => this.downloadClicked()} href="#">
                            {I18N("PDF")}
                        </button>
                    )}

                    {APP.settings.enableBasket && (
                        <button
                            className="button primary big-button"
                            disabled={valid.length != 0 || !Commons.isEmpty(APP.configuration.ordered_at)}
                            onClick={() => this.putIntoBasket()} href="#">
                            {I18N("basket")}
                        </button>
                    )}
                </div>
            </div>
        );
    }
}
